import { render, staticRenderFns } from "./InvitePeopleForm.vue?vue&type=template&id=66a531e1"
import script from "./InvitePeopleForm.vue?vue&type=script&lang=js"
export * from "./InvitePeopleForm.vue?vue&type=script&lang=js"
import style0 from "./InvitePeopleForm.vue?vue&type=style&index=0&id=66a531e1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports